import React from 'react';
import {
  FormDefinition,
  FormState,
  forms,
  FormField,
  Toggle, Textarea
} from "../lib/forms";
import {Checkbox} from "./forms/Checkbox";
import Input from "./forms/Input";
import SelectInput from "./SelectInput";
import has from "lodash/has";
import pick from "lodash/pick";
import {
  IonButton,
  IonIcon, IonItem,
  IonLabel,
  IonProgressBar,
  IonSpinner
} from "@ionic/react";
import SearchInput from "./SearchInput";
import {save} from "ionicons/icons";
import get from "lodash/get";
import {AppState} from "../models/app";
import {AppDispatch, RootState} from "../global.state";
import {actions} from "../lib/app";
import {connect} from "react-redux";
import DateInput from "./DateInput";
import {debug} from "../config";
import FileInput from "./FileInput";

type StateSet = {
  [name:string]: any;
}
export type onChangeCallback = (value:any,
                                state: FormState) => StateSet|void;

interface ModelFormHOCProps {

}

interface ModelFormHOCState {

}

export const buildModelForm = (ModelForm: any): any => {
  class ConnectedModelForm extends React.Component<ModelFormHOCProps, ModelFormHOCState> {
    constructor(props: ModelFormProps) {
      super(props);

      this.state = {

      };
    }

    render() {
      return (
        <ModelForm
          {...this.props}
        />
      );
    }
  }

  return ConnectedModelForm;
};


export interface ModelFormProps {
  app: AppState;
  dispatch: AppDispatch;
  formDefinition: FormDefinition;
  instance?: any;
  defaultValues?: any;
  onCreate: (values:any) => Promise<any>;
  onUpdate: (values:any) => Promise<any>;
  onComplete: () => void;
  onValidate?: (values:any) => boolean;
  onValidateAsync?: (values:any) => Promise<boolean>;
  ownerId: string;
  gender: 'm' | 'f';
  entityLabel: string;
  noSuccessMessage?: boolean;
  submitLabel: string;
}

interface ModelFormState {
  formState: FormState;
  gravando: boolean;
}

export const ModelFormContext = React.createContext({
  formDefinition: {},
  onChangeValue: (fieldName:string, value:any, touched:boolean, setValues?:StateSet) => {},
  formState: {},
});

class _ModelForm extends React.Component<ModelFormProps, ModelFormState> {
  public static defaultProps = {
    submitLabel: 'Gravar',
  };

  constructor(props: ModelFormProps) {
    super(props);

    // if instance is set use instance else use defaultValues
    const values = props.instance ? props.instance : props.defaultValues;

    this.state = {
      formState: forms.buildFormState(props.formDefinition, values),
      gravando: false,
    }
  }

  onChangeValue = (fieldName:string, value:any, touched:boolean=true, setValues?:StateSet) => {
    this.setState((state, props) => {
      const fieldState = forms.validateField(
        this.props.formDefinition[fieldName],
        state.formState[fieldName],
        value,
        touched
      );

      const newState:FormState = {
        [fieldName]: fieldState,
      };

      if (setValues) {
        for (const fName in setValues) {
          newState[fName] = forms.validateField(
            this.props.formDefinition[fName],
            state.formState[fName],
            setValues[fName],
            false,
          );
        }
      }

      return {
        formState: {
          ...state.formState,
          ...newState,
        },
      }
    });
  };

  onClickEnviar = async () => {
    const {result, state} = forms.validate(this.props.formDefinition, this.state.formState);
    let isValid = result.success;

    if (isValid) {
      if (this.props.onValidate)
        isValid = this.props.onValidate(result.values);
      else if (this.props.onValidateAsync)
        isValid = await this.props.onValidateAsync(result.values);
    }

    if (isValid) {
      this.setState({gravando: true, formState: state});
      try {
        const message = await this.submitForm(result.values);
        if (!this.props.noSuccessMessage)
          this.props.dispatch(actions.notifySuccess(message));
        this.setState({gravando: false});
        this.props.onComplete();
      } catch (e: any) {
        this.reportError(e.toString());
        this.setState({gravando: false});
      }
    } else {
      this.setState({formState: state});
      this.reportError('Verifique os campos indicados com erro no formulário.');
    }
  };

  reportError = (error: string) => {
    this.props.dispatch(actions.notifyError(error));
  };

  async submitForm(values:any): Promise<string> {
    values.owner = this.props.ownerId;
    if (this.props.instance) {
      // atualizar
      const msg = `${this.props.entityLabel} atualizad${this.props.gender === 'm' ? 'o' : 'a'} com sucesso.`;
      await this.props.onUpdate(values);

      if (this.props.app.online) {
        return msg;
      } else {
        return `(Offline) ${msg}`;
      }
    } else {
      // criar
      const msg = `${this.props.entityLabel} inserid${this.props.gender === 'm' ? 'o' : 'a'} com sucesso.`;

      await this.props.onCreate(values);
      if (this.props.app.online) {
        return msg;
      } else {
        return `(Offline) ${msg}`;
      }
    }
  }

  render() {
    return (
      <ModelFormContext.Provider
        value={{
          formDefinition: this.props.formDefinition,
          onChangeValue: this.onChangeValue,
          formState: this.state.formState,
        }}
      >
        <div>
          {this.props.children}

          <div className="mt-8 flex w-full justify-center">
            <IonButton
              onClick={this.onClickEnviar}
              disabled={this.state.gravando}
            >
              {
                this.state.gravando ?
                  <IonSpinner slot="start" className="mr-2"/> :
                  <IonIcon icon={save} slot="start"/>
              }
              {this.props.submitLabel}
            </IonButton>
          </div>
        </div>
      </ModelFormContext.Provider>
    )
  }
}

export const ModelForm = connect(({app}: RootState) => ({app}))(_ModelForm);

interface ModelFormFieldProps {
  field: string;
  options: any[];
  optionLabel?: string;
  optionValue?: string;
  loading: boolean;
  disabled: boolean;
  onChange?: onChangeCallback;
  onBlur?: onChangeCallback;
  presentation?: "date" | "date-time" | "month" | "month-year" | "time" | "time-date" | "year";
  monthShortNames?: string[];
  rows?: number;
  max?: string;
  min?: string;
  className?: any;
  labelPosition: "floating" | "fixed" | "stacked" | undefined;
  multiple?: boolean;
  interfaceOptions?: any;
  getOptionLabel?: (instance: any) => any;
}

export class ModelFormField extends React.Component<ModelFormFieldProps, any> {
  static contextType = ModelFormContext;

  public static defaultProps = {
    labelPosition: 'floating',
    options: [],
    loading: false,
    disabled: false,
  }

  onChange = (fieldName:string, value:any) => {
    let setStates;
    if (this.props.onChange)
      setStates = this.props.onChange(value, this.context.formState);

    this.context.onChangeValue(fieldName, value, true, setStates);
  };

  onBlur = (fieldName:string, value:any) => {
    if (this.props.onBlur)
      this.props.onBlur(value, this.context.formState);
  };

  render() {
    const formDef:FormDefinition = this.context.formDefinition;
    const field = formDef[this.props.field];
    const {getOptionLabel} = this.props;

    if (!field)
      throw Error(`Field ${this.props.field} not defined.`);

    let inputField: React.ReactElement = <>Error: {field.type} is undefined</>;
    const disabled = has(this.props, 'disabled') ? this.props.disabled : false;

    const {formState} = this.context;
    const fieldState = formState[field.name];
    if (!fieldState) {
      debug(`ModelForm(${field.name})`, 'no state, skip render');
      return null;
    }

    switch (field.type) {
      case "string":
      case "telefone":
      case "number":
      case "cep":
      case "email":
      case "currency":
      case "cnpj":
        inputField = (
          <Input
            key={`field_${field.name}`}
            definition={field}
            onChange={this.onChange}
            onBlur={this.onBlur}
            state={fieldState}
            disabled={disabled}
          />
        );
        break;
      case "text":
        inputField = (
          <Textarea
            key={`field_${field.name}`}
            definition={field}
            onChange={this.onChange}
            state={fieldState}
            rows={get(this.props, 'rows', 4)}
          />
        );
        break;
      case "boolean":
        inputField = (
          <Toggle
            key={`field_${field.name}`}
            definition={field}
            onChange={this.onChange}
            state={fieldState}
            disabled={disabled}
          />
        );
        break;
      case "date":
        const dateExtraProps = {};
        Object.assign(dateExtraProps,
          pick(this.props, ['presentation', 'min', 'max']));

        inputField = (
          <DateInput
            key={`field_${field.name}`}
            definition={field}
            onChange={this.onChange}
            state={fieldState}
            disabled={disabled}
            {...dateExtraProps}
          />
        );
        break;
      case "checkbox":
        requiredProps(field, this.props, ['options']);

        inputField = (
          <Checkbox
            key={`field_${field.name}`}
            options={this.props.options!}
            definition={field}
            onChange={this.onChange}
            state={fieldState}
          />
        );
        break;
      case "select":
      case "select-multiple":
        requiredProps(field, this.props, ['options']);

        // chech wich type of option we are using
        if (this.props.options && typeof this.props.options[0] === 'object')
          requiredProps(field, this.props, ['optionLabel', 'optionValue']);

        // select multiple
        const multiple = (field.type === 'select-multiple' || this.props.multiple) ? true : false;
        const options = this.props.options;

        const selectIsLoading = has(this.props, 'loading') && this.props.loading;

        inputField = (
          <>
            {selectIsLoading &&
                <WaitLoading
                  label={field.label}
                  required={field.required}
                  labelPosition={this.props.labelPosition}
                />
            }
            {!selectIsLoading &&
              <SelectInput
                definition={field}
                onChange={this.onChange}
                state={fieldState}
                options={options}
                labelField={this.props.optionLabel}
                valueField={this.props.optionValue}
                disabled={disabled || !fieldState || !options || options.length === 0}
                multiple={multiple}
                interfaceOptions={this.props.interfaceOptions}
                getOptionLabel={getOptionLabel}
              />
            }
          </>
        );
        break;
      case "searchInput":
        requiredProps(field, this.props, ['options', 'optionLabel', 'optionValue']);

        inputField = (
          <>
            {has(this.props, 'loading') && this.props.loading ?
              <WaitLoading
                label={field.label}
                required={field.required}
                labelPosition={this.props.labelPosition}
              /> :
              <SearchInput
                collection={this.props.options}
                labelField={this.props.optionLabel!}
                valueField={this.props.optionValue!}
                onChange={this.onChange}
                state={fieldState}
                definition={field}
                disabled={disabled}
                getOptionLabel={getOptionLabel}
                interfaceOptions={this.props.interfaceOptions}
              />
            }
          </>
        );
        break;
      case "raw-upload":
        inputField = (
          <>
            <FileInput
              key={`field_${field.name}`}
              onChange={this.onChange}
              state={fieldState}
              definition={field}
              disabled={disabled}
            />
          </>
        );
        break;
    }

    return (
      <div className={this.props.className}>
        {inputField}
      </div>
    )
  }
}

function requiredProps(field:FormField, props:any, propNames:string[]) {
  propNames.forEach(prop => {
    if (!has(props, prop)) {
      throw Error(`Field ${field.name} requires prop ${prop}`);
    }
  });
}

interface WaitLoadingProps {
  label: string;
  required: boolean | undefined;
  labelPosition: "floating" | "fixed" | "stacked" | undefined;
}

const WaitLoading: React.FC<WaitLoadingProps> = ({label, required, labelPosition}) => {
  return (
    <IonItem className="pr-1">
      <IonLabel position={labelPosition}>
        {label} {required && '*'}
      </IonLabel>

      <IonProgressBar type="indeterminate"/>

    </IonItem>
  );
}
